import { Settings, WidgetData } from "./data"
import { Widget } from "./widget"

export type HtmlData = WidgetData & {
  settings: Settings & {
    html: string,
  }
  widgetType: "html"
}

export class HtmlWidget extends Widget {
  html: string | null

  constructor(data: HtmlData) {
    super(data);
    this.html = data.settings.html ?? null;
  }
}
